import {
  LocationFeatureFlagSettingName,
  LocationFeatureSettings,
} from '@weave/schema-gen-ts/dist/schemas/payments/messages/location_settings/location_settings.pb';

export enum PaymentsFeatureFlags {
  PaymentWritebacks = 'Payment Writeback',
  PaymentEaglesoftWritebacks = 'Payment Eaglesoft Writeback',
  TtpAuthentication = 'payments:ttp-attachment-authentication',
  TtpAuthenticationToggle = 'payments:ttp-authentication-ff-toggle',
  ShowStripeAffirmPaymentToggle = 'payments:show-stripe-affirm-payment-toggle',
  ShowStripeAffirmPaymentOption = 'payments:show-stripe-affirm-payment-option',
  PaymentsMultiLocationFeature = 'Payments_multi_location_feature',
  PaymentDrChronoWritebacks = 'Payment DrChrono Writeback',
  showDrChronoWritebacksToggle = 'payments-dr-chrono-writebacks-toggle',
  PaymentLinkMessaging = 'payments:payment-link-messaging',
  ACHOnFile = 'payments:ach-on-file',
  EnableLeftShiftingMoneyFields = 'payments-left-shifting-money-fields',
  EnableAddACH = 'payments-enable-add-ach',
  EnableACHBalanceCheck = 'payments:enable-ach-balance-check',
  EnableJustifyOnboarding = 'payments:platform-aci-justifi-onboarding:enabled',
  canUseSyncCreateIntentEndpoint = 'payments:nwx:sync-create-intent-endpoint',
  CollectPaymentOnABTest = 'collect-payment-ON-a-b-test',
  ShareInEmail = 'payments:share-in-email',
  PayoutDescriptorColumn = 'payments:payout-descriptor-column',
  JustifiTerminalDevOverride = 'payments:justifi-terminal-development-collection',
  DxeCollectionFlow = 'payments:aci-dxe-collections',
  PayoutsServiceV1 = 'payouts-service-v1',
  PayoutsServiceV1DetailView = 'payouts-service-v1-detail-view',
  AutoReceiptEnabled = 'payments:receipt-settings',
  ObpNewFields = 'payments:obp-new-fields',
}

export const paymentsLocationFeatureSettings = {
  [LocationFeatureFlagSettingName.UNSPECIFIED]: 'locationId',
  [LocationFeatureFlagSettingName.EAGLESOFT_WRITEBACKS_ENABLED]: 'eaglesoftWritebacksEnabled',
  [LocationFeatureFlagSettingName.DR_CHRONO_WRITEBACKS_ENABLED]: 'drChronoWritebacksEnabled',
  [LocationFeatureFlagSettingName.OPEN_DENTAL_WRITEBACKS_ENABLED]: 'openDentalWritebacksEnabled',
  [LocationFeatureFlagSettingName.TTP_AUTH_ENABLED]: 'ttpAuthEnabled',
  [LocationFeatureFlagSettingName.FUSE_WRITEBACKS_ENABLED]: 'fuseWritebacksEnabled',
  [LocationFeatureFlagSettingName.OPEN_DENTAL_CLOUD_WRITEBACKS_ENABLED]: 'openDentalCloudWritebacksEnabled',
  [LocationFeatureFlagSettingName.DENTRIX_ENTERPRISE_WRITEBACKS_ENABLED]: 'dentrixEnterpriseWritebacksEnabled',
  [LocationFeatureFlagSettingName.DOLPHIN_CLOUD_WRITEBACKS_ENABLED]: 'dolphinCloudWritebacksEnabled', // Added Dolphin Cloud mapping
  [LocationFeatureFlagSettingName.OPEN_DENTAL_LOCAL_WRITEBACKS_ENABLED]: 'openDentalLocalWritebacksEnabled',
  [LocationFeatureFlagSettingName.AUTO_RECEIPT_ENABLED]: 'autoReceiptEnabled',
  [LocationFeatureFlagSettingName.SURCHARGING_ENABLED]: 'surchargingEnabled',
  [LocationFeatureFlagSettingName.DOLPHIN_WRITEBACKS_ENABLED]: 'dolphinWritebacksEnabled',
  [LocationFeatureFlagSettingName.ONLINE_BILL_PAY_PATIENT_BIRTHDATE_ENABLED]: 'onlineBillPayPatientBirthdateEnabled',
  [LocationFeatureFlagSettingName.ONLINE_BILL_PAY_PATIENT_IDENTIFIER_ENABLED]: 'onlineBillPayPatientIdentifierEnabled',
  [LocationFeatureFlagSettingName.CRYSTAL_WRITEBACKS_ENABLED]: 'crystalWritebacksEnabled',
  [LocationFeatureFlagSettingName.ATHENA_ONE_WRITEBACKS_ENABLED]: 'athenaOneWritebacksEnabled',
  [LocationFeatureFlagSettingName.NEXTECH_SELECT_WRITEBACKS_ENABLED]: 'nextechSelectWritebacksEnabled',
  [LocationFeatureFlagSettingName.NEXTECH_PRACTICE_WRITEBACKS_ENABLED]: 'nextechPracticeWritebacksEnabled',
  [LocationFeatureFlagSettingName.DOLPHIN_LEGACY_WRITEBACKS_ENABLED]: 'dolphinLegacyWritebacksEnabled',
} as const satisfies Partial<Record<LocationFeatureFlagSettingName, keyof LocationFeatureSettings>>;

export type PaymentsFeatureSettings = keyof typeof paymentsLocationFeatureSettings;

export const paymentFeatureSettingsWithValues = {
  [LocationFeatureFlagSettingName.SURCHARGING_ENABLED]: 'surchargePercentage',
} as const satisfies Partial<Record<LocationFeatureFlagSettingName, keyof LocationFeatureSettings>>;

export type PaymentFeatureSettingsValues = keyof typeof paymentFeatureSettingsWithValues;

export type PaymentFeatureSettingsValuesMap<T extends PaymentFeatureSettingsValues> =
  LocationFeatureSettings[(typeof paymentFeatureSettingsWithValues)[T]];
